import {styled} from '@mui/material';
import {Option as BaseOption} from '@mui/base/Option/Option';
import {optionClasses} from '@mui/base/Option';

const Listbox = styled('ul')(
    (theme) => `
  display: flex;
  width: max-content;
  margin: 0;
  padding: 0.2rem 0;
  flex-direction: column;
  align-items: flex-start; 
  overflow: auto;
  outline: 0px;
  background: var(--background-additional);
  color: var(--text-secondary);
  border-radius: 0.4211rem;
  min-width: 8.21rem;
  overflow-y: auto;
  
  font-size: 0.7875rem;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  width: 100% !important;
  `,);

export const Option = styled(BaseOption)(
    ({ theme }) => `
  display: flex;
  padding: 12px;
  align-items: center;
  gap: 0.9rem;
  align-self: stretch; 
  cursor: pointer;
  color: var(--text-secondary);
  margin: 0;
  width: 100% !important;

  & span {
    flex: 1;
    min-width: 0;
  }

  & svg {
    color: transparent;
    transition: color 0.2s ease;
  }

  &:last-of-type {
    border-bottom: none;
  }

  &.${optionClasses.selected} {
    color: var(--text-primary);
    & svg {
      color: var(--text-primary);
    }
  }

  &.${optionClasses.highlighted} {
    color: var(--text-primary);
    & svg {
      color: var(--text-primary);
    }
  }

  &.${optionClasses.highlighted}.${optionClasses.selected} {
    color: var(--text-primary);
    & svg {
      color: var(--text-primary);
    }
  }
  
  &:hover {
    background: var(--hover-menu);
    & svg {
      color: var(--text-primary);
    }
  }

  &:hover:not(.${optionClasses.disabled}) {
    color: var(--text-primary);
  }

  position: relative;
  z-index: 9999;
  `,
);

export default Listbox;
